var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9606 3.28401C2.50491 3.89443 2.88764 4.73486 3.67934 4.8623L7.36742 5.45595C8.22644 5.59422 8.91146 4.80189 8.57385 4.06053L8.12183 3.06795C8.70719 2.91983 9.31198 2.83105 9.92571 2.80538C11.7375 2.7296 13.5256 3.20812 15.0119 4.16646C16.4982 5.12481 17.5993 6.50926 18.144 8.10441C18.6886 9.69956 18.6462 11.416 18.0233 12.9866C17.4005 14.5572 16.2321 15.894 14.7 16.7889C13.1679 17.6838 11.358 18.0867 9.55184 17.9349C7.74569 17.7832 6.04458 17.0852 4.71318 15.9496C3.38179 14.814 2.49475 13.3045 2.19009 11.656C2.08778 11.1023 1.51812 10.73 0.917721 10.8243C0.31732 10.9187 -0.0864633 11.444 0.0158476 11.9976C0.402203 14.0882 1.52709 16.0025 3.2155 17.4426C4.90392 18.8827 7.06117 19.7678 9.35165 19.9603C11.6421 20.1528 13.9374 19.6418 15.8803 18.5069C17.8232 17.372 19.3049 15.6768 20.0948 13.685C20.8846 11.6932 20.9384 9.51658 20.2478 7.49369C19.5571 5.4708 18.1607 3.71512 16.2759 2.49979C14.391 1.28446 12.1234 0.677633 9.82578 0.773723C8.95061 0.810326 8.08979 0.94813 7.26222 1.18031L7.00855 0.623294C6.67094 -0.11807 5.57781 -0.221906 5.08338 0.44042L2.9606 3.28401Z",
    fill: "#9EA9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.3c598ccd93e22bccb819a0fcd5bb820c.svg";
export { ForwardRef as ReactComponent };